module.exports = __webpack_public_path__ + "img/img_xinghe_20201207@2x.37314830.png";